import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getPublicationCountPerType } from "../../../../state/selectors/Publications.selectors";
import { getQueryType } from "../../../../state/selectors/general.selectors";
import isPortal from "../../../../common/helpers/isPortal";

function PublicationsCardContent({ queryType, publicationCounts }) {
  if (isPortal()) return null;

  return (
    <div className="tw-font-bold">
      {queryType === "gene" || queryType === "cnv" ? null : (
        <div>
          <span className="tw-pr-1 tw-font-normal">Variant:</span>
          <span data-testid="publications-variant">
            {publicationCounts.variant}
          </span>
        </div>
      )}
      {queryType === "cnv" ? null : (
        <div>
          <span className="tw-pr-1 tw-font-normal">Genes:</span>
          <span data-testid="publications-gene">{publicationCounts.gene}</span>
        </div>
      )}
      {queryType === "cnv" ? (
        <div>
          <span className="tw-pr-1 tw-font-normal">Regions:</span>
          <span data-testid="publications-region">
            {publicationCounts.region}
          </span>
        </div>
      ) : null}
    </div>
  );
}

PublicationsCardContent.propTypes = {
  publicationCounts: PropTypes.shape({
    variant: PropTypes.number,
    gene: PropTypes.number,
    region: PropTypes.number,
  }),
  queryType: PropTypes.string,
};

PublicationsCardContent.defaultProps = {
  publicationCounts: {
    variant: 0,
    gene: 0,
    region: 0,
  },
  queryType: null,
};

const mapStateToProps = (state) => ({
  publicationCounts: getPublicationCountPerType(state),
  queryType: getQueryType(state),
});

export default connect(mapStateToProps)(PublicationsCardContent);
